import { actionCreator,
  API_URL,
  checkHttpStatus,
  createSearchUrlForCustomAPI,
  DELETEROUNDINGRULE,
  GET_MASTERDATABYNAME,
  GETROUNDINGRULE,
  GETROUNDINGRULEBYID,
  jsonApiHeader,
  roundingRuleActionTypes,
  ROUNDINGRULEAPI,
  showErrorMessage,
  showSuccessMessage,
} from '../constants/ApiConstants';
import { showWarningMessage } from '../../manageTags/constants/ApiConstants';
import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';


export const getMasterData = () => {
  let fetchUrl = `${GET_MASTERDATABYNAME}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(roundingRuleActionTypes.get_masterdata.REQUEST));
    fetch(fetchUrl, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'appointmentType,masterstaff,MASTERPATIENTLOCATION' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(roundingRuleActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error get_masterdata search --', error);
      });
  };
};

export const getRoundingRuleById = (ruleId) => {
  let fetchUrl = `${GETROUNDINGRULEBYID}?id=${ruleId}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(roundingRuleActionTypes.get_rounding_rule_byId.REQUEST));
    fetch(fetchUrl, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        //  console.log('getRoundingRuleById response --', response);
        dispatch(actionCreator(roundingRuleActionTypes.get_rounding_rule_byId.SUCCESS, response));
      })
      .catch(function(error) {

        dispatch(actionCreator(roundingRuleActionTypes.get_rounding_rule_byId.FAILURE));
        console.log('error get_rounding_rule  --', error);
      });
  };
};


export const getRoundingRule = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  // console.log('query_params---', query_params);
  let fetchUrl = `${GETROUNDINGRULE}${query_params}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(roundingRuleActionTypes.get_rounding_rule.REQUEST));
    fetch(fetchUrl, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response --', response);
        dispatch(actionCreator(roundingRuleActionTypes.get_rounding_rule.SUCCESS, response));
      })
      .catch(function(error) {

        dispatch(actionCreator(roundingRuleActionTypes.get_rounding_rule.FAILURE));
        console.log('error get_rounding_rule  --', error);
      });
  };
};

export const saveRoundingRule = (formProps) => {
  // console.log('formProps ===', formProps);
  let fetchMethod = 'POST';
  let roundingRuleArray = [];
  // function deleted(index) {
  //   let IsDeleted = false;
  //   if (index > 0) {
  //     if (formProps.deletedRows.indexOf(index) !== -1) {
  //       IsDeleted = true;
  //     }
  //   }
  //   return IsDeleted;
  // }
  if (formProps.roundingRuleDetail.length > 0) {
    formProps.roundingRuleDetail.map((obj, index) => {
      let newObj = {};
      newObj.IsDeleted = obj.isDeleted ? obj.isDeleted : false;
      newObj.StartRange = obj.startRange;
      newObj.EndRange = obj.endRange;
      newObj.Unit = obj.unit;
      newObj.id = obj.id ? obj.id : 0;
      roundingRuleArray.push(newObj);
      return roundingRuleArray;
    });
  }
  let PostData = JSON.stringify({
    RuleName: formProps.ruleName,
    RoundingRuleDetail: roundingRuleArray,

  });
  let UpdateData = JSON.stringify({
    id: formProps.id,
    RuleName: formProps.ruleName,
    RoundingRuleDetail: roundingRuleArray,

  });
  let formPostData = (formProps.id) ? UpdateData : PostData;
  // console.log('formPostData........', formPostData);
  return (dispatch, getState) => {
    dispatch(actionCreator(roundingRuleActionTypes.post_rounding_rule.REQUEST));
    fetch(`${ROUNDINGRULEAPI}`, {
      method: fetchMethod,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: formPostData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(roundingRuleActionTypes.post_rounding_rule.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
        }
      })
      .catch(function(error) {
        console.log('error----', error);
      });
  };
};
export const deleteRoundingRule = (id) => {
  return (dispatch, getState) => {

    dispatch(actionCreator(roundingRuleActionTypes.delete_rounding_rule.REQUEST));

    fetch(`${DELETEROUNDINGRULE}?Id=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response....',response);
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(roundingRuleActionTypes.delete_rounding_rule.SUCCESS, {}));
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
          dispatch(actionCreator(roundingRuleActionTypes.delete_rounding_rule.SUCCESS, {}));
        } else if (response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(roundingRuleActionTypes.delete_rounding_rule.SUCCESS, response));
        } else {
          dispatch(actionCreator(roundingRuleActionTypes.delete_rounding_rule.SUCCESS, {}));
          showErrorMessage(response.message);
        }
      }).catch(function(error) {
        // console.log(error);
        showErrorMessage('Oops, something went wrong, please try later');
        dispatch(actionCreator(roundingRuleActionTypes.delete_rounding_rule.SUCCESS, {}));
      });
  };
};

export const updateFieldsOnRemove = (updateFromIndex) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(roundingRuleActionTypes.update_from_index.SUCCESS, updateFromIndex));
  };
};


export const asyncValidateAction = (postData, resolve, reject, access_token) => {
  // return (dispatch, getState) => {
  //   // dispatch(actionCreator(appConfigActionTypes.field_exist_error.REQUEST));

  fetch(`${API_URL}/CheckIfRecordExists`, {
    method: 'post',
    body: JSON.stringify(postData),
    headers: jsonApiHeader(access_token, 'application/json'),
  })
    .then(checkHttpStatus)
    .then(function(response) {
      if (!(response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204)) {
        reject({ ruleName: response.message });
      } else {
        resolve();
      }
      // console.log('input.response...........', response);
      // dispatch(actionCreator(appConfigActionTypes.field_exist_error.SUCCESS, response));
    })
    .catch(function(error) {
      console.log('error: ', error);
    });
  // };
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/rounding-rule/actions/RoundingRuleActions.js